import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'reports-analytics-header',
  templateUrl: './analytics-header.component.html',
  styleUrls: ['./analytics-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportAnalyticsHeaderComponent {}
